interface IParams {
  isMasterMoneySource: boolean;
  canPayByCard: boolean;
}

export const getPayUrl = (params: IParams): string | undefined => {
  const { isMasterMoneySource, canPayByCard } = params;

  return !isMasterMoneySource && !canPayByCard ? 'https://my.cian.ru/pay' : undefined;
};
